import countryData from "@CheckOrder/data/countryData.json";
import find from "lodash/find";

// Return first match. Start with longer input as otherwise we'd always match 3 char values
export const matchLongestValidDialCode = (phoneNumber) => {
    const match = (length) => find(countryData, {dialCode: phoneNumber.substring(0, length)})
    return match(5) || match(4) || match(3)
}